import React from "react";
import ButtonSmallIcon from "../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import { WithModalConfirmation } from "../../../../../common/components/organisme/ModalWindow/ModalWindow";

import useSingleStation from "../../../hooks/useSingleStation";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";
import NewStationModal from "../../NewStation/NewStationModal/NewStationModal";
import useQueryURL from "../../../../../common/hooks/useQueryURL";

export default function SingleStationActionBtnPresenter() {
  const {singleStationQuery:{data}, deleteStationQuery} = useSingleStation()
  const navigationApp = useNavigationApp()
  const {setQueryValue} = useQueryURL()

  const {userRole} = useAuth()
  const handleDelete = () => {
    deleteStationQuery.mutate({callback: ({result, error}) => {
        if (!error) {
          navigationApp.goToStationList()
        }
    }})
  }

  if (userRole && userRole <= userRoles.USER){
    return <></>
  }

  const MODAL_ID = "modal_update_station"
  const goToModifyStation = () => {
    setQueryValue({[MODAL_ID]: "true"})
  }
  return (
    <div style={{ display: "flex", gap: 10 }}>
      <ButtonSmallIcon
        iconType={"edit-sheet"}
        label="Modifier"
        variant="stack"
        onClick={goToModifyStation}
      />
      <WithModalConfirmation
        modalTitle={"Confirmation"}
        confirmLabel="Supprimer"
        cancelLabel="Annuler"
        modalDescription={"Êtes-vous sûr de vouloir supprimer la station "+data?.station_name+" ?"}
        onComfirm={handleDelete}
        buttonRender={({openModal}) => (
          <ButtonSmallIcon
            iconType={"trash"}
            label="Supprimer"
            variant="stack"
            onClick={openModal}
          />
        )}
      />
      <NewStationModal modalId={MODAL_ID} stationIdToUpdate={data?.station_id} />
    </div>
  );
}
